const addingQuestionsAllowed = (game_type) =>
    game_type === 'first_scorer' || game_type === 'favorite_player' ? false : true;

const deletingQuestionsAllowed = (game_type) =>
    game_type === 'first_scorer' || game_type === 'favorite_player' ? false : true;

const questionsConfig = { addingQuestionsAllowed, deletingQuestionsAllowed };

export default questionsConfig;
